import { hooks } from '@bilibili-maoer/web-utils'

import { NavigateFunction, NavigateOptions, useNavigate } from 'react-router-dom'

import { prepareToProps } from './prepare-to-props'

import { useAppSelector } from '~/app/hooks'

export default function useAppNavigate() {
  const routerNavigate = useNavigate()
  const navHide = useAppSelector((state) => state.Ui.navHide)

  const navigate: NavigateFunction = (to, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      return routerNavigate(to)
    }
    return routerNavigate(prepareToProps(to, navHide), options)
  }

  return hooks.useEventCallback(navigate) as NavigateFunction
}
